import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { HelpBoxComponent, HelpBoxModel } from '@frontend/sports/help-box/feature';

@Component({
    selector: 'ms-bog-help',
    template: ` <ms-help-box [data]="helpData" (closeButtonClick)="closeClick.emit()" /> `,
    imports: [HelpBoxComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BestOddsGuaranteeHelpComponent {
    readonly sitecore = inject(Sitecore);

    readonly closeClick = output();

    readonly helpData: HelpBoxModel = {
        badgeText: this.sitecore.horseRacing.badges.BOG,
        headerTitle: this.sitecore.horseRacing.helpBox.HeaderLine,
        infoIconLink: this.sitecore.horseRacing.helpBox.InfoIconLink,
        explanationText: this.sitecore.horseRacing.helpBox.Text,
    };
}
